import React from 'react';

import { Checkbox, FormControl } from '@rbilabs/universal-components';
import { FieldProps } from 'formik';
import { Typography } from 'ucl/components/text/Typography';

import { getDesignToken } from 'styles/constants';

import { FormContainer, LabelContainer } from './styled';

export interface ICheckboxProps {
  label: React.ReactNode;
  errorMessage?: string;
  alignItems?: string;
}

export const FormikCheckbox: React.FC<React.PropsWithChildren<FieldProps & ICheckboxProps>> = ({
  form,
  field,
  ...props
}) => {
  const { label } = props;
  const { name } = field;
  const { setFieldValue } = form;
  const checked = !!form.values[name];

  const errorMessage =
    form.errors[name] && form.touched[name] ? (form.errors[name] as string) : undefined;
  return (
    <FormControl>
      <FormContainer>
        <Checkbox
          {...field}
          {...props}
          onChange={isSelected => setFieldValue(name, isSelected)}
          defaultIsChecked={checked}
        >
          {label && (
            <LabelContainer $alignItems={props.alignItems}>
              <Typography>{label}</Typography>
            </LabelContainer>
          )}
        </Checkbox>
      </FormContainer>
      {errorMessage && (
        <Typography pl="$3" fontSize="xs" color={getDesignToken('color-error')}>
          {errorMessage}
        </Typography>
      )}
    </FormControl>
  );
};
